var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-meta',{attrs:{"count":_vm.pages.length,"label":"Pages","intro":"All pages on this site affected by this card."}},_vm._l((_vm.pages),function(p){return _c('page-item',{key:p.id,staticClass:"ps-mt-6",attrs:{"page":p}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }